import { Typography } from '@mui/material'
import React from 'react'
import { Trans } from 'react-i18next'
import { ChargingScheduleFormFieldNames, ChargingScheduleFormType, RepeatOptions } from 'src/Libs/e-mobility/vehicle-integration'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { formatDayList } from '../../../functions'
import WeekDaysBold from '../WeekDaysBold'
import { useFormContext, useWatch } from 'react-hook-form'
import { format } from '@e3dc-react/shell/Libs/date'

/**
 * Translation Component for weekly recurring charging form
 */
const ScheduleDescription: React.FC = () => {
  const { t } = useCustomTranslation()
  const { control } = useFormContext<ChargingScheduleFormType>()
  const repeat = useWatch({ control, name: ChargingScheduleFormFieldNames.Repeat })
  const startDate = useWatch({ control, name: ChargingScheduleFormFieldNames.StartDate })
  const endDate = useWatch({ control, name: ChargingScheduleFormFieldNames.EndDate })
  const selectedWeekDays = useWatch({ control, name: ChargingScheduleFormFieldNames.SelectedWeekDays })

  const isValidDate = (d: unknown): d is Date => d instanceof Date && !isNaN(d.getTime())
  const formattedStartDate = isValidDate(startDate) ? format(startDate, t('common.format.date-fns-date')) : ''
  const formattedEndDate = endDate && isValidDate(endDate) ? format(endDate, t('common.format.date-fns-date')) : ''

  if (repeat === RepeatOptions.daily)
    return (
      <Typography variant="body2" textAlign="center">
        <Trans
          i18nKey="emobility.vehicle-integration.charging-schedule.daily-schedule-description"
          components={{
            startDate: <Typography variant="body2" component="strong" sx={{ fontWeight: 'bold' }} />,
            endDate: <Typography variant="body2" component="strong" sx={{ fontWeight: 'bold' }} />,
          }}
          values={{ startDate: formattedStartDate, endDate: formattedEndDate }}
        />
      </Typography>
    )

  const weekDaysString = formatDayList(selectedWeekDays, t)

  if (!weekDaysString || repeat !== RepeatOptions.weekly) return null

  return (
    <Typography variant="body2" textAlign="center">
      <Trans
        i18nKey="emobility.vehicle-integration.charging-schedule.weekly-schedule-description"
        components={{
          weekDays: <WeekDaysBold weekDays={weekDaysString} />,
          startDate: <Typography variant="body2" component="strong" key="start-date" sx={{ fontWeight: 'bold' }} />,
          endDate: <Typography variant="body2" component="strong" key="end-date" sx={{ fontWeight: 'bold' }} />,
        }}
        values={{ weekDays: weekDaysString, startDate: formattedStartDate, endDate: formattedEndDate }}
      />
    </Typography>
  )
}

export default ScheduleDescription
